import { progressVariants } from './progressVariants';

import type { DetailedHTMLProps, ProgressHTMLAttributes } from 'react';

export type ProgressProps = DetailedHTMLProps<ProgressHTMLAttributes<HTMLProgressElement>, HTMLProgressElement> & {
  /** Make progress bar take full width of its container */
  fullWidth?: boolean;
  /** Maximum value
   * @default 100
   */
  max?: number;
  /** Current progress value (0-100)
   * @default 0
   */
  value?: number;
};

export const Progress = ({ className, fullWidth, max = 100, value = 0, ...props }: ProgressProps) => {
  const progressClasses = progressVariants({ className, fullWidth });

  return <progress className={progressClasses} max={max} value={value} {...props} />;
};
